import ServiceTemplate from '@/components/template/service/ServiceTemplate';
import { Form, Title, Space, Button, Input, Row, Col } from '@/components/atoms';
import FormItem from '@/components/atoms/form/FormItem';

const ServiceManageApiPage = () => {
  return (
    <ServiceTemplate>
      <Title>API 설정</Title>
      <Form layout="vertical">
        <Row>
          <Col span={24}>
            <FormItem label="고지서 등록 인증키">
              <Input style={{ flex: 1 }} />
              <Button shape="round">복사</Button>
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem label="고지서 조회 인증키">
              <Input style={{ flex: 1 }} />
              <Button shape="round">복사</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </ServiceTemplate>
  );
};

export default ServiceManageApiPage;
